(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var banner = document.querySelector('[data-sale-banner]');
    var headerEl = document.querySelector('[data-header-height]');
    var navRow = document.querySelector('[data-collection-tools]');
    var footerEl = document.querySelector('footer.footer') || document.querySelector('footer');
    if (!banner || !headerEl) return;

    var ticking = false;
    var footerVisible = false;

    if (footerEl) {
      var footerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          footerVisible = entry.isIntersecting;
        });
        onScrollOrResize();
      }, { threshold: 0 });
      footerObserver.observe(footerEl);
    }

    function update() {
      var headerBottom = headerEl.getBoundingClientRect().bottom;
      if (headerBottom <= 0 || headerBottom > 160) {
        headerBottom = 100;
      }

      var bannerTop = headerBottom;
      if (navRow && window.innerWidth <= 479) {
        var navBottom = navRow.getBoundingClientRect().bottom;
        if (navBottom > headerBottom && navBottom <= 250) {
          bannerTop = navBottom;
        }
      }
      banner.style.top = bannerTop + 'px';
      banner.classList.toggle('is-visible', window.scrollY > 220 && !footerVisible);
      ticking = false;
    }

    function onScrollOrResize() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    update();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    window.addEventListener('orientationchange', onScrollOrResize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    if (window.mobileSearchInit) return;
    window.mobileSearchInit = true;

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-mobile-search-toggle]');
      if (!toggle) return;
      e.preventDefault();

      var panel = document.querySelector('[data-mobile-inline-search]');
      if (!panel) return;

      var isOpen = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (isOpen) {
        var input = panel.querySelector('input[type="search"]');
        if (input) {
          input.setAttribute('autocomplete', 'off');
          input.setAttribute('autocorrect', 'off');
          input.setAttribute('autocapitalize', 'off');
          input.setAttribute('spellcheck', 'false');
          input.focus();
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
